import { Box, Typography } from "@mui/material";
import CardBase from "../../../components/CardBase";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { GlobalContext } from "../../../../../common/Context";
import RenderTrypAccordion from "../../../../../common/RenderTrypAccordion";
import { grey } from "../../../../../../theme/colours";
import ReBox from "../../../../../common/ReBox";
import LoadingWheel from "../../../../../common/LoadingWheel";
import { DASHBOARD_RECENT_TRYPS } from "../../../../../../constants/ids";

const RecentTryps = (props) => {
  const { tryps } = props;
  const { t } = useTranslation("Dashboard");
  const { userState, mobileView, tabletView, largeView } =
    useContext(GlobalContext);

  const nav =
    (userState.isViewer || userState.isAdmin || userState.isMedidas) && "tryps";

  const trypsBoxStyle = {
    width: largeView ? "25%" : tabletView ? "49%" : mobileView ? "100%" : "30%",
    mb: mobileView && "1rem",
  };
  const trypBoxAreaStyle = {
    width: "100%",
    height: "100%",
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  };
  const containerStyle = { m: "1rem 1.5rem", p: 0 };
  const noTrypsBox = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    padding: "2rem",
    flexDirection: "column",
  };
  const errorSubTitleStyle = {
    opacity: "50%",
    mt: "0.5rem",
    textAlign: "center",
    width: "350px",
    lineHeight: "1.5",
  };

  return (
    <CardBase
      title={t("myRecentTryps")}
      headerColor={grey[1]}
      redirect={nav}
      boxStyle={trypsBoxStyle}
      areaStyle={trypBoxAreaStyle}>
      {tryps ? (
        tryps.length > 0 ? (
          <ReBox
            style={containerStyle}
            divProps={{ id: DASHBOARD_RECENT_TRYPS }}>
            {tryps.map((tryp, index) => (
              <RenderTrypAccordion key={index} tryp={tryp} disable />
            ))}
          </ReBox>
        ) : (
          <Box sx={noTrypsBox}>
            <Typography variant="h4">{t("noTrypsT")}</Typography>
            <Typography sx={errorSubTitleStyle}>{t("noTrypsD")}</Typography>
          </Box>
        )
      ) : (
        <Box sx={noTrypsBox}>
          <LoadingWheel width={3} />
        </Box>
      )}
    </CardBase>
  );
};

export default RecentTryps;
